import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';

import { Dialog, DialogContent, DialogTitle } from '@mui/material';

import { loadVacancyAuditData } from '../../../store/recruitmentService';
import Button from '../../formElements/Button';

import AuditVacancyManagement from './AuditVacancyManagement';

import modal from '../../../commonStyles/modal.module.css';

const AuditVacancyModal = ({ isOpen, vacancyId, label, onClose }) => {
    const dispatch = useDispatch();

    // USE EFFECTS
    useEffect(() => {
        if (vacancyId && label && isOpen) dispatch(loadVacancyAuditData(vacancyId, label));
    }, []);

    return (
        <Dialog
            onClose={onClose}
            open={isOpen}
            onClick={(e) => e.stopPropagation()}
            className="muiDialogWrapper"
            id="auditModal">
            <div className={modal.modalHeader}>
                <DialogTitle>{label} Change History</DialogTitle>
            </div>
            <DialogContent>
                <>
                    <div className={modal.mainContent}>
                        <AuditVacancyManagement />
                    </div>
                    <div className={modal.actionButtons}>
                        <div className={modal.cancelButton}>
                            <Button id="auditModalButton" onClick={onClose} content="Close" />
                        </div>
                    </div>
                </>
            </DialogContent>
        </Dialog>
    );
};

AuditVacancyModal.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    vacancyId: PropTypes.string,
    label: PropTypes.string,
    onClose: PropTypes.func.isRequired
};

export default AuditVacancyModal;
